<!-- PanelItem.vue -->
<template>
  <div class="panel-container my-2">
    <div class="pannel-bar">
      <div
        ref="pannel"
        class="panel-item d-flex justify-content-between align-items-center"
        @click="$emit('toggle')"
      >
        <div class="d-flex align-items-center">
          <svg-icon
            aria-label="share"
            class="svg-icon-share stat-item-icon mr-1"
            :icon-name="getIconLabel(isOpen)"
          ></svg-icon>
          <span class="label">{{ getLabel() }}</span>
        </div>
        <div class="d-flex align-items-center">
          <span :class="isValuePresent ? 'label' : 'text-italic'">{{ limiteValue }}</span>
          <div
            v-show="isDeleteBtn && category !== 'deposit'"
            class="btn-delete ml-1"
            @click.stop="$bvModal.show(confirmationUUID)"
          >
            <svg-icon icon-name="ic-corbeille" className="iconeCorbeille"></svg-icon>
          </div>
        </div>
      </div>
    </div>
    <!-- Fenêtre modale de confirmation optionnelle -->
    <b-modal
      :id="confirmationUUID"
      centered
      hide-footer
      hide-header
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="compteClair modale-container">
        <div v-html="jel_replaceTokens(content.confirmationSupp)"></div>
        <div class="modale-pannel-btn">
          <b-button class="btn btn-primaire-secondaire" @click="$bvModal.hide(confirmationUUID)">
            {{ content.libBtnAnnuler }}
          </b-button>
          <b-button
            class="btn btn-primaire-limite"
            @click="$bvModal.hide(confirmationUUID), deleteLimit()"
          >
            {{ content.libBtnModaleConfirmer }}
          </b-button>
        </div>
      </div>
    </b-modal>

    <div class="panel-item-limit" @close="$emit('toggle')">
      <transition name="slide-down">
        <LimitForm
          v-if="isOpen"
          ref="limitform"
          :category="category"
          :period="period"
          :content="content"
          @success-limitSet="getlimitMessageAndCloseForm"
        />
      </transition>
    </div>
    <MessageMel
      v-show="isAlerteExist"
      class="info-text px-2 pt-2 pb-0"
      :content="contentMessageMel.alert"
    />
  </div>
</template>
<script>
import LimitForm from '@/components/compte/bienJouer/LimitForm.vue';
import encadrerJeux from '@/services/api/compte/encadrerJeux';
import MessageMel from '@/components/base/MessageMel';
import i18n from '@/js/i18n';
import MessageHelpers from '@/helpers/MessageHelpers';
import { formatMontant } from '@/helpers/StringHelpers';
import { bus } from '@/main';

export default {
  name: 'PanelItem',
  components: { LimitForm, MessageMel },
  props: {
    content: { type: Object, required: false },
    period: { type: String },
    category: { type: String },
    isOpen: { type: Boolean, default: false },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          pasLimite: 'Aucune limite',
          limiteActuelle: 'Limite actuelle',
        },
      },
      en: {
        messageComponent: {
          pasLimite: 'No limit',
          limiteActuelle: 'Current limit',
        },
      },
    },
  },
  data() {
    return {
      confirmationUUID: this.uid,
      isSubmitted: false,
      isDeleteBtn: false,
      isValuePresent: true,
      isAlerteExist: false,
      limiteValue: this.$i18n.t('messageComponent.pasLimite'),
      contentMessageMel: {
        alert: {},
      },
    };
  },

  mounted() {
    this.getlimitMessage();
    // Écouter l'événement
    bus.$on('get-limit-received', this.getlimitMessage);
  },
  beforeDestroy() {
    // Nettoyer l'écouteur
    bus.$off('get-limit-received', this.getlimitMessage);
  },

  methods: {
    getlimitMessage() {
      const limitPeriod = this.$store.getters['encadrerJeux/getLimitValue'](
        this.category,
        this.period
      );

      if (!limitPeriod) {
        return;
      }

      if (limitPeriod.actuelValue) {
        this.limiteValue =
          this.category === 'time'
            ? `${limitPeriod.actuelValue.replace(/\.\d+$/, '')} h`
            : formatMontant(limitPeriod.actuelValue);
        this.isDeleteBtn = true;
        this.isValuePresent = true;
      } else {
        this.isValuePresent = false;
      }

      if (limitPeriod.message) {
        let codeMsg = '';
        // important, si futureValue est présente avec le message; il s'agit d'un pending update
        if (limitPeriod.futureValue) {
          codeMsg = i18n.t(`validations.messages.encadrerJeux.infoLimite.${this.category}`);
        }
        // sinon si futureValue=null  est présente avec le message; il s'agit d'un pending delete
        else {
          codeMsg = i18n.t(`validations.messages.encadrerJeux.deleteLimite.${this.category}`);
        }
        this.recupererMessage(codeMsg, 'alert', {
          periode: this.$i18n.t(`compte.limite.${this.period}`),
          valeur: this.getValeurFormater(limitPeriod.futureValue),
          date: this.getDateInsecable(limitPeriod.message),
        });
        this.isAlerteExist = true;
      } else {
        this.isAlerteExist = false;
      }
    },

    getlimitMessageAndCloseForm() {
      this.closePannelIfItsOpen();
      this.getlimitMessage();
    },

    openPannelIfItsClose() {
      if (!this.isOpen) {
        this.$refs.pannel.click();
      }
    },

    closePannelIfItsOpen() {
      if (this.isOpen) {
        this.$refs.pannel.click();
      }
    },

    getLabel() {
      if (this.category === 'deposit') {
        return this.$i18n.t(`messageComponent.limiteActuelle`);
      }
      const s = this.$i18n.t(`compte.limite.${this.period}`);
      return s.charAt(0).toUpperCase() + s.slice(1);
    },

    getIconLabel(isOpen) {
      return isOpen ? 'ic-vector-open' : 'ic-vector-close';
    },

    deleteLimit() {
      if (this.isSubmitted) {
        return;
      }
      this.isSubmitted = true;
      encadrerJeux
        .deleteLimiteJeux({ category: this.category, period: this.period })
        .then((response) => {
          this.getlimitMessage();
          this.isSubmitted = false;
          this.isDeleteBtn = false;
          console.log('response : ', response);
          this.$bvModal.hide(this.confirmationUUID);
          this.closePannelIfItsOpen();
        })
        .catch((error) => {
          console.error('Erreur de récupération des données!');
          // ouvrir le formulaire et puis affiché le message d'erreur, s'il n'est pas déja ouvert
          this.openPannelIfItsClose();
          // Envoie du message au limitForm enfant pour l'affichage
          this.$nextTick(() => {
            if (this.$refs.limitform && this.$refs.limitform.affichageMessageErreur) {
              this.$refs.limitform.affichageMessageErreur('MSG01', 'message');
            }
          });
          this.isSubmitted = false;
          this.$bvModal.hide(this.confirmationUUID);
        });
    },

    // TODO mettre cette fonction dans le helper
    recupererMessage(codeMessage, contentMessage, keysValueRemplacement = {}) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          let messageTraiter = msgResp.msgDetail;
          if (keysValueRemplacement) {
            Object.entries(keysValueRemplacement).forEach(([cle, valeur]) => {
              const regex = new RegExp(`\\{{${cle}\\}}`, 'g');
              messageTraiter = messageTraiter.replace(regex, valeur);
            });
          }
          this.contentMessageMel[contentMessage] = {
            titre: msgResp.msgTitre,
            message: messageTraiter,
            msgType: msgResp.msgType,
          };
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },

    getValeurFormater(valeur) {
      if (valeur == null) {
        return '';
      }
      const result =
        this.category === 'time' ? valeur.replace(/\.\d+$/, '') : formatMontant(valeur);
      return result.replace(/ /g, '&nbsp;');
    },

    getDateInsecable(date) {
      const lang = this.$i18n.locale;
      switch (lang) {
        case 'en':
          return date
            .replace(/(\w+)\s+(\d+),/g, '$1&nbsp;$2,')
            .replace(/(\d+),\s+(\d+),/g, '$1,&nbsp;$2,')
            .replace(/(\d+:\d+)\s+(a\.m\.|p\.m\.)/g, '$1&nbsp;$2');
        default:
          return date
            .replace(/(\d+)\s+(\w+)\s+(\d+)/g, '$1&nbsp;$2&nbsp;$3')
            .replace(/(\d+)\s+h\s+(\d+)/g, '$1&nbsp;h&nbsp;$2')
            .replace(/(\d+)\s+(min|sec)/g, '$1&nbsp;$2');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .modal-dialog {
  max-width: 440px !important;
}
.pannel-bar {
  height: 2.5rem;
  margin: 0;
  align-items: center;
  align-self: stretch;
  background: $couleur-bg-form-bien-jouer;
  border-bottom: solid 1px #ddd8c5;
  cursor: pointer;
}

.panel {
  display: flex;
  justify-content: space-between;
}

.panel-item {
  height: 2.5rem;
  padding: 0 0.5rem;
}

.info-text {
  display: flex;
  padding: 0.5rem;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 0.25rem;
  background: #e5e6ff;

  @media (min-width: 768px) {
    margin-top: 0.5rem !important;
  }
}

.stat-item-icon {
  display: flex;
  width: 1rem;
  height: 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.btn-delete {
  height: 1.5rem;
}

.label {
  font-weight: bold;
}
.text-italic {
  font-style: italic;
}
.btn {
  display: flex;
  height: 3rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex: 1 0 0;
  border-radius: 1.5rem;
  color: black;
  font-weight: bold;
  border: 1px solid $couleur-btn-bien-jouer;
  &:active,
  &:focus,
  &:hover {
    background: $couleur-btn-hover-bien-jouer;
    border-color: $couleur-btn-hover-bien-jouer;
    color: black;
  }
}

.btn-primaire-limite {
  background: $couleur-btn-bien-jouer;
  margin: 0;
}

.btn-primaire-secondaire {
  background: $couleur-blanc;
  margin: 0;
  &:active,
  &:focus,
  &:hover {
    color: black;
  }
}

.modale-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3rem;
  align-self: stretch;
  padding: 1rem;
}
.modale-pannel-btn {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
}
/* Transitions */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  transform-origin: top;
}

.slide-down-enter {
  opacity: 0;
  transform: scaleY(0);
}

.slide-down-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
</style>
